import {ENV_CONFIG, DEFAULT_CONFIG} from './constants';

const configOverride = ENV_CONFIG ?? {ssoConfigs: {}};

// todo: type configOverride
if (configOverride.baseApiUrl) {
  configOverride.designerBaseApiUrl = configOverride.baseApiUrl;
}

const ssoConfigsOverride = configOverride.ssoConfigs ?? {};

export const config = {
  ...DEFAULT_CONFIG,
  ...configOverride,
  ssoConfigs: {
    ...DEFAULT_CONFIG.ssoConfigs,
    ...ssoConfigsOverride,
  },
};

if (!config.designerBaseApiUrl) {
  config.designerBaseApiUrl = config.baseApiUrl;
}

export * from './constants';
